if(!customElements.get('swym-wishlist-page')){
    class SwymWishlistPage extends HTMLElement{
        constructor(){
            super();
            this._initializeSwymComponent();
        }

        _init(swat){
            this._initializeSelectors(swat);
            this.isShareWishlistPage ? this._renderShareWishlist(swat) : this._renderWishlist(swat);
            this._attachEventListeners();
        }

        /* General functions */

        _initializeSwymComponent(){
            if (!window.SwymCallbacks) window.SwymCallbacks = [];
            window.SwymCallbacks.push(this._init.bind(this));
        }

        _initializeSelectors (swat){
            this.lists = [];
            this.swat = swat;
            this.body = document.body;
            this.settings = JSON.parse(this.dataset.settings);
            this.isShareWishlistPage = window.isShareListPage;
            this.isShareEnabledUsingSocialMedia = swat.retailerSettings.Wishlist.AllowSharing;
            this.wishlistVariants = {};

            /* Page Header Selectors */ 
            this.accountButton = this.querySelector('#swymcs-user-login-status-btn');
            this.accountPopup = this.querySelector('#swymcs-user-login-status-popup');
            this.accountPopupCloseButton = this.querySelector('#swymcs-close-account-popup');
            this.accountPopupCancelButton = this.querySelector('#swymcs-cancel-account-popup');
            this.accountPopupActionButton = this.querySelector('#swymcs-account-login-action-button');
            this.pageTitleWishlistNumber = this.querySelector('#swymcs-page-title-number');

            /* Wishlist grid container */
            this.emptyListContainer = this.querySelector('#swym-empty-wishlist-container'); 
            this.wishlistContainer = this.querySelector('#swymcs-wishlist-container');
            this.listsContainer = this.querySelector('#swymcs-lists-grid');
            this.listProductsContainer = this.querySelector('#swymcs-products-grid-container');
            this.productsContainer = this.querySelector('#swymcs-products-grid');
            this.wishlistHeader = this.querySelector('#swymcs-wishlist-header');
            this.backToListView = this.querySelector('#swymcs-back-to-lists-view');
            this.pageLoader = this.querySelector("#swymcs-loader-container");

            /* Additional Options selectors */ 
            this.additionalOptionsContainer = this.querySelector('#swymcs-additional-options');
            this.additionalOptionsBtn = this.querySelector('#swymcs-view-additional-options');
            this.shareListButton = this.querySelector('#swymcs-share-list');
            this.deleteListButton = this.querySelector('#swymcs-delete-list');

            /* Additional Options popup selectors */
            this.additionalOptionsPopupContainer = this.querySelector('#swymcs-additional-options-popup-container');
            this.additionalOptionsPopupCloseButton = this.querySelector('#swymcs-close-additional-popup');
            this.additionalPopupCancelButtons = this.querySelectorAll('.swymcs-additonal-popup-cancel-button');

            /* Share List popup selectors */ 
            this.shareListPopup = this.querySelector('#swymcs-share-list-popup');
            this.shareLinkField = this.querySelector('#swymcs-share-link-field');
            this.shareNameField = this.querySelector('#swymcs-share-name-field');
            this.shareEmailField = this.querySelector('#swymcs-share-email-field');
            this.shareMessageField = this.querySelector('#swymcs-share-message-field');
            this.shareListError = this.querySelector('#swymcs-share-email-field-error');
            this.emailShareButton = this.querySelector('#swymcs-confirm-share-list');
            this.additionalShareButtonsContainer = this.querySelector('.swymcs-additional-share-buttons-container');
            this.copyLinkButton = this.querySelector('#swymcs-confirm-share-list--copy');
            this.facebookShareButton = this.querySelector('#swymcs-confirm-share-list--facebook');
            this.twitterShareButton = this.querySelector('#swymcs-confirm-share-list--twitter');
            
            /* Delete List popup selectors */ 
            this.deleteListPopup = this.querySelector('#swymcs-delete-list-popup');
            this.deleteListName = this.querySelector('#swymcs-confirm-delete-list-name');
            this.confirmDeleteListButton = this.querySelector('#swymcs-confirm-delete-list'); 

            this.productsContainer.addEventListener('click', this._eventsForProductsGrid);
            this.productsContainer.addEventListener('change', this._eventsForProductsGrid);
        }

        _attachEventListeners(){
            this.body.addEventListener('click', evt => this._overlayEvent(evt));

            /* Adding events to page header elements */ 
            this.accountButton.addEventListener('click', evt => this._showPopupContainer(this.accountPopup));
            this.accountPopupCloseButton.addEventListener('click', evt => this._hidePopupContainer(this.accountPopup));
            this.accountPopupCancelButton.addEventListener('click', evt => this._hidePopupContainer(this.accountPopup));
            this.accountPopupActionButton.addEventListener('click', this._loginButtonAction.bind(this));

            /* Additional Options Events */     
            this.additionalOptionsBtn.addEventListener('click', evt => this._showPopupContainer(this.additionalOptionsContainer));   
            this.additionalOptionsContainer.addEventListener('click', this._renderAdditionalOptionsPopup);
            this.shareListButton.addEventListener('click', this._renderShareListPopup.bind(this));

            /* Additional Options Popup Events */
            this.additionalPopupCancelButtons.forEach(btn => btn.addEventListener('click', this._closeAdditionalOptionsPopup.bind(this)));
            this.additionalOptionsPopupCloseButton.addEventListener('click', this._closeAdditionalOptionsPopup.bind(this));
             
            /* Share List Events */
            this.copyLinkButton.addEventListener('click', this._shareListByCopy.bind(this));
            this.emailShareButton.addEventListener('click', this._shareListByEmail.bind(this));
            this.facebookShareButton.addEventListener('click', evt => this._shareListOnPlatform('facebook'));
            this.twitterShareButton.addEventListener('click', evt => this._shareListOnPlatform('twitter'));
            this.shareEmailField.addEventListener('input', this._validateEmail.bind(this));

            /* Delete List Events */ 
            this.confirmDeleteListButton.addEventListener('click', this._deleteList.bind(this));
        }
        
        async _renderWishlist(){
            this.lists = await this._getCompleteListDetails();
            this.lists.length ?  this._renderSingleList() : this._renderEmptyState();
        }

        async _renderShareWishlist(){
            const lid = new URL(document.location).searchParams.get("lid");
            
            // Common UI updates
            const updateUI = (showHeader = true) => {
                this._showContainer(this.listProductsContainer);
                this._showContainer(this.wishlistContainer);
                this._hideContainer(this.pageLoader);
                this._hideContainer(this.backToListView);
                if (!showHeader) {
                    this._hideContainer(this.wishlistHeader);
                }
            };

            if(!lid){
                this._renderProductsGrid([]);
                updateUI(false);
                return;
            }

            window.currentActiveListId = lid;
            try {
                const wishlistProducts = await this._getProductsFromList(lid);
                this.listcontents = await this._getShopifyProductsData(wishlistProducts);         
                if(!this.listcontents || !this.listcontents.length){
                    this._renderEmptyList();
                    updateUI(false);
                    return;
                }
                
                await this._renderSharedListHeader(lid);
                this._renderProductsGrid(this.listcontents);
                if(window.isLoggedIn && window.isStoreOwner ) this._showCopyLinkInput();
                updateUI();
            } catch (error) {
                console.error('Error fetching wishlist products:', error);
                this._renderEmptyList();
                updateUI(false);
            }
        }

        async _renderSingleList() {
            if (this.list && this.list.listcontents) {
                this._hideContainer(this.pageLoader);
                this._showContainer(this.wishlistHeader);
                this._renderProductsGrid(this.list.listcontents);
                this._showContainer(this.wishlistContainer);
                this._showContainer(this.listProductsContainer);
                return;
            }

            this.lists = await this._getLists();
            if (!this.lists.length) {
                this._renderEmptyState();
                return;
            }
            this.list = this.lists.find(list => list.lname.toLowerCase() == 'my wishlist') || this.lists[0];
            window.currentActiveListId = this.list.lid;
            this.list.listcontents = await this._getProductsFromList(this.list.lid);
            this.list.listcontents = await this._getShopifyProductsData(this.list.listcontents);

            // Cache the list data
            this.list = this._setListProperties(this.list, this.list.listcontents, true);

            this._hideContainer(this.pageLoader);
            await this._renderSingleListHeader(this.list.lid);
            this._renderProductsGrid(this.list.listcontents);
            this._showContainer(this.wishlistContainer);
            this._showContainer(this.listProductsContainer);
        }

        _renderMultipleList() {
            if(!this.lists.length){
                this._renderEmptyState();
                return;
            }
            this._renderListsView();
            this.emptyListContainer.classList.add('swym-hide-container');
            this.wishlistContainer.classList.remove('swym-hide-container');
        }

        _renderEmptyState(){
            this._hideContainer(this.pageLoader);
            this.emptyListContainer.classList.remove('swym-hide-container');
            this.wishlistContainer.classList.add('swym-hide-container');
        }

        async _renderListsView(){
            window.currentActiveListId = '';
            const html = this.lists.map(list => {
                const productCount = list.totalProducts || 0;
                const buttonText = !productCount ? 'Continue Shopping' : 'View List';
                const buttonAction = !productCount ? 'shop' : 'view-list';
                
                const imageHtml = this._generateListPreviewImages(list);
                
                return `
                    <button class="swymcs-button swymcs-list-item swymcs-wishlist-grid-item" 
                            data-lid="${list.lid}" 
                            aria-label="View list ${list.lname}" 
                            id="list--${list.lid}">
                        <div class="swymcs-list-title-container">
                            <div class="swymcs-list-title">${list.lname}</div>
                        </div>
                        <div class="swymcs-list-product-count-container">
                            <span class="swymcs-product-count">${productCount}</span>
                            <span class="swymcs-product-count-text">${productCount > 1 ? 'products' : 'product'}</span>
                        </div>
                        ${imageHtml}
                        <div class="swymcs-view-list-button swymcs-major-button" 
                             data-action="${buttonAction}" 
                             id="swymcs-view-list-button-${list.lid}" 
                             aria-label="${buttonText}">
                            ${buttonText}
                        </div>
                    </button>
                `;
            }).join('');

            this.listsContainer.innerHTML = html;
            this._showContainer(this.listsContainer);
            this._hideContainer(this.listProductsContainer);
            this._hideContainer(this.pageLoader);
            this._scrollToTop();
        }

        _generateListPreviewImages(list) {
            const listContents = list?.listcontents || [];
            let imageHtml = `<div class="swymcs-list-image-container">`;
            
            if(listContents.length) {
                for(let i = 0; i < 3; i++) {
                    if(listContents[i]) {
                        const product = listContents[i].productData;
                        const selectedVariant = product.variants.find(variant => variant.id === listContents[i].epi);
                        const imageSrc = selectedVariant?.featured_image?.src || product?.featured_image ||  listContents[i].iu;
                        imageHtml += `
                            <div class="swymcs-wishlist-image-wrapper">
                                <img src="${imageSrc}" 
                                     alt="${listContents[i].productData.title}" 
                                     class="swymcs-wishlist-image"/>
                            </div>`;
                    }
                }
                imageHtml += '</div>';
            } else {
                imageHtml += `<p class="swymcs-no-products-message">This is an empty list!</p></div>`;
            }
            
            return imageHtml;
        }

        async _renderListProducts(lid){
            this._hideContainer(this.listsContainer);
            this._showContainer(this.pageLoader);
            this._showContainer(this.wishlistHeader);
            this._showContainer(this.backToListView);
            window.currentActiveListId = lid;
            
            const selectedList = this.lists.find(list => list.lid == lid);
            if(!selectedList.allProductsLoaded) {
                const allProducts = await this._getProductsFromList(lid);
                selectedList.listcontents = await this._getShopifyProductsData(allProducts);
                selectedList.allProductsLoaded = true;
            }
            
            this._renderListHeader(lid);
            this._hideContainer(this.pageLoader);
            this._renderProductsGrid(selectedList.listcontents);
            this._showContainer(this.listProductsContainer);
        }

        async _renderSharedListHeader(lid){
            const { list: activeList } = await this._getListDetails(lid);
            activeList.listcontents = this.listcontents;
            this._hideContainer(this.wishlistHeader);
            this._hideContainer(this.additionalOptionsBtn);
            this._hideContainer(this.shareListButton);
        }

        async _renderSingleListHeader(lid){
            this._showContainer(this.additionalOptionsBtn);
            this._hideContainer(this.backToListView);
            this._hideContainer(this.pageLoader);
        }

        _renderListHeader(lid){
            const lists = this.lists; 
            const activeList = lists.find(list => list.lid == lid);
            let html = ``;
            lists.forEach((list, index) => {
                const listContents = list?.listcontents || [];
                if(listContents.length){
                    const product = listContents[0].productData;
                    const selectedVariant = product.variants.find(variant => variant.id === listContents[0].epi);
                    const imageSrc = selectedVariant?.featured_image?.src || product?.featured_image || listContents[0].iu;
                    html += `
                    <li class="swymcs-header-list-item" data-lid="${list.lid}">
                        <img src="${imageSrc}" alt="${list.lname}"/>
                        <span class="swym-list-item">${list.lname} (${listContents.length})</span>
                    </li>`
                }else {
                    html += `
                    <li class="swymcs-header-list-item" data-lid="${list.lid}">
                        <span class="swymcs-list-item-image-text">${list.lname[0]}</span>
                        <span class="swymcs-list-item">${list.lname} (0)</span>
                    </li>`
                }
            })
        }

        _renderProductsGrid(shopifyProducts, type = 'wishlist'){
            if(!shopifyProducts.length) {
                this._renderEmptyList();
                return;
            }
            this.pageTitleWishlistNumber.textContent= `(${shopifyProducts.length})`;
            let productMarkup = ``;
            shopifyProducts.forEach(async (pdp, index) => {
                if(!pdp) return;
                const variants = pdp.productData.variants;
                const options = pdp.productData.options;
                const product = pdp.productData;
                const selectedVariant = product.variants.find(variant => variant.id === pdp.epi);
                const selectedVariantTitle = selectedVariant.title && selectedVariant.title.toLowerCase() != 'default title' ? selectedVariant.title : '';
                const selectedVariantPrice = (price => Number.isInteger(price) ? price.toString() : price.toFixed(2))(selectedVariant.price / 100);
                const selectedVariantCompareAtPrice = selectedVariant.compare_at_price > 0 && selectedVariant.compare_at_price != selectedVariant.price ? parseFloat(selectedVariant.compare_at_price/100.00).toFixed(2) : 0;
                const labelText = product.metafieldData != 'NA' ? product.metafieldData : '';
                const inCart = _swat.platform.isInDeviceCart(selectedVariant.id) ? 'swymcs-product-in-cart' : '';
                const lid = pdp.lid;
                let isSoldOut = !selectedVariant.available ? 'swymcs-sold-out' : '';
                const imageSrc = selectedVariant?.featured_image?.src || product?.featured_image ||  pdp.iu; 
                const productUrl = pdp?.product?.du || pdp.du;
                let skuColorArray = [];
                let sizeArray = [];
                const sizeOption = options.find(opt => opt.name.toLowerCase() === "size");
                const colorOption = options.find(opt => opt.name.toLowerCase() === "color");
                let colorOptionIndex, sizeOptionIndex;

                if (colorOption && colorOption.values.length > 1) {          
                    colorOptionIndex = colorOption.position;
                    skuColorArray = variants.reduce((acc, variant) => {
                        const baseSku = variant.sku.split('-')[0];
                        const color = variant[`option${colorOptionIndex}`];
                        const image = variant?.featured_image?.src || product?.featured_image || pdp.iu;
                        const existingColor = acc.find(item => item.sku === baseSku);
                        if (!existingColor) {
                            const colorVariants = variants.filter(v => v[`option${colorOptionIndex}`] === color);
                            const isAvailable = colorVariants.some(v => v.available === true);
                            acc.push({ sku: baseSku, color, image, available: isAvailable });
                        }
                        return acc;
                    }, []);
                    console.log("skucolorarray", skuColorArray);
                }

                if (sizeOption && sizeOption.values.length > 1) {
                    sizeOptionIndex = sizeOption.position;
                    sizeArray = variants.reduce((acc, variant) => {
                        const size = variant[`option${sizeOptionIndex}`];
                        if (!acc.find(item => item.size === size)) {
                            acc.push({ size, available: variant.available });
                        }
                        return acc;
                    }, []);
                }           

                let addToCartBtnText = (sizeOption && sizeOption.values.length > 1) 
                    ? "Select a Size" 
                    : (selectedVariant.available 
                        ? (_swat.platform.isInDeviceCart(selectedVariant.id) 
                            ? this.settings.added_to_cart_text 
                            : this.settings.add_to_cart_text) 
                        : this.settings.sold_out_text);

                let preOrder = ``;

                if (product.tags?.some(tag => tag.toLowerCase() === "pre-order")) {
                   preOrder = `<div class="fs-preorder">PREORDER</div>`;
                }

                let isButtonDisabled = (sizeOption && sizeOption.values.length > 1) ? 'disabled' : (isSoldOut ? 'disabled' : '');

                this.wishlistVariants[pdp.empi] = {};
                let variantsHTML = `<div class="swymcs-variant-selector container" bis_skin_checked="1">`;
 
                    product.variants.forEach((variant, index) => {
                        const variantCost = parseFloat(variant.price/100.00).toFixed(2);
                        let isSelectedVariant = variant.id == selectedVariant.id ? 'swym-selected-variant' : ''; 
                        let isVariantAvailable = variant.available ? 'data-available="true"' : 'data-available="false" style="text-decoration: line-through"';
                        let isInCart = _swat.platform.isInDeviceCart(variant.id);
                        variantsHTML += `<button data-variant-cost="${variantCost}" data-purpose="select" ${isVariantAvailable} data-variant-id="${variant.id}" data-product-id="${product.id}" class="${isSelectedVariant} swymcs-variant-selector-btn" aria-label="Select ${variant.title}">${variant.title}</button>`;

                        // Make sure the product entry exists
                        if (!this.wishlistVariants[pdp.empi]) {
                            this.wishlistVariants[pdp.empi] = {};
                        }

                        // Extract colour and size from this variant, using "single" as placeholder if missing
                        const colorKey = colorOptionIndex ? variant['option' + colorOptionIndex] : "single";
                        const sizeKey  = sizeOptionIndex  ? variant['option' + sizeOptionIndex]  : "single";

                        // Initialise the colour object if it doesn’t exist
                        if (!this.wishlistVariants[pdp.empi][colorKey]) {
                            this.wishlistVariants[pdp.empi][colorKey] = {};
                        }

                        // Assign the variant ID
                        this.wishlistVariants[pdp.empi][colorKey][sizeKey] = {epi: variant.id,available: variant.available,inCart: isInCart};
                    })

                variantsHTML += `</div>`;

                let swatchMoreHTML = `
                    <a href="${productUrl}"><div class="fs_show_more_csm"><svg viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:sketch="http://www.bohemiancoding.com/sketch/ns" fill="#000000"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <title>plus-circle</title> <desc>Created with Sketch Beta.</desc> <defs> </defs> <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" sketch:type="MSPage"> <g id="Icon-Set" sketch:type="MSLayerGroup" transform="translate(-464.000000, -1087.000000)" fill="#000000"> <path d="M480,1117 C472.268,1117 466,1110.73 466,1103 C466,1095.27 472.268,1089 480,1089 C487.732,1089 494,1095.27 494,1103 C494,1110.73 487.732,1117 480,1117 L480,1117 Z M480,1087 C471.163,1087 464,1094.16 464,1103 C464,1111.84 471.163,1119 480,1119 C488.837,1119 496,1111.84 496,1103 C496,1094.16 488.837,1087 480,1087 L480,1087 Z M486,1102 L481,1102 L481,1097 C481,1096.45 480.553,1096 480,1096 C479.447,1096 479,1096.45 479,1097 L479,1102 L474,1102 C473.447,1102 473,1102.45 473,1103 C473,1103.55 473.447,1104 474,1104 L479,1104 L479,1109 C479,1109.55 479.447,1110 480,1110 C480.553,1110 481,1109.55 481,1109 L481,1104 L486,1104 C486.553,1104 487,1103.55 487,1103 C487,1102.45 486.553,1102 486,1102 L486,1102 Z" id="plus-circle" sketch:type="MSShapeGroup"> </path> </g> </g> </g></svg></div></a>
                `;
                let swatches=``;
                if (skuColorArray && skuColorArray.length > 0){
                    swatches += `<div class="swymcs-swatches color-swatches fs-result-page-1xgbzd0 ${skuColorArray.length > 5 ? 'swymcs-more' : ''}" data-in-hover="" data-client-x="404" data-client-y="221">`;
                    skuColorArray.forEach((item, index) => {
                        if (index < 4) {
                          const imageUrl = `https://sfycdn.speedsize.com/2d6a4e72-831a-41e3-80b0-b68f3b452c84/www.terijon.com/cdn/shop/t/64/assets/${item.sku}.jpg`;
                          swatches += `
                            <span class="color-swatch-container fs-color-swatch-container" tabindex="0" role="button" aria-label="; Variant: ${item.color}">
                              <span class="color-swatch fast-swatch-color-fallback ${item.available === false ? 'swym-greyscale' : ''} ${item.color === selectedVariant[`option${colorOptionIndex}`] ? 'swym-selected-swatch' : ''}" 
                                data-purpose="swatch"
                                data-color="${item.color}"
                                data-colorindex="${colorOptionIndex}"
                                data-image="${item.image}"
                                title="${item.color}"
                                style="--swatch-width: 17px; --swatch-height: 17px; background-image: url('${imageUrl}');">
                              </span>
                            </span>
                          `;
                        } else if (index === 4) {
                          swatches += swatchMoreHTML;
                        }
                      });
                      swatches += `</div>`;
                }

                let sizeDropDown=``;
                console.log("sizeArray",sizeArray);     
                if (sizeArray && sizeArray.length > 0){
                    sizeDropDown += `<select name="swymcs-size-select" data-purpose="select" class="swymcs-size-select"><option value="" disabled selected>Size</option>`;
                    sizeArray.forEach(item => {
                        sizeDropDown += `<option value="${item.size}" ${!item.available?'disabled':''}>${item.size}</option>`
                    });
                    sizeDropDown += `</select>`
                }

                // ${item === selectedVariant[`option${sizeOptionIndex}`] ? 'selected' : ''}

                productMarkup += `
                    <li id="wishlist-grid-item--${index}"  data-url="${productUrl}" data-lid="${lid}" data-epi="${selectedVariant.id}" data-empi=${product.id} class="grid__item swymcs-product-card">
                        <div class="card-wrapper swymcs-list-product product-card-wrapper underline-links-hover" bis_skin_checked="1">
                            <button data-list-type="${type}" data-lid="${lid}" data-purpose="delete" data-epi="${selectedVariant.id}" data-empi="${product.id}" data-du="${pdp.du}" class="${this.isShareWishlistPage && 'swym-hide-container'} swymcs-button swymcs-product-delete-btn" aria-label="Delete ${product.title}">
                                <span class="swym-icon">${this.settings.swym_delete_list_icon}</span>
                            </button>
                            <div class="card card--standard card--media" style="--ratio-percent: 100%;" bis_skin_checked="1">
                                <div class="card__inner color-scheme-2 gradient ratio" style="--ratio-percent: 100%;aspect-ratio:2/3;display: flex;align-items: center;" bis_skin_checked="1">
                                    <div class="card__media" bis_skin_checked="1">
                                        <div class="media media--transparent media--hover-effect" bis_skin_checked="1">
                                            <a href="${productUrl}" aria-label="Visit ${product.title} page"><img src="${imageSrc}" alt="${product.title}" class="motion-reduce" loading="lazy"/></a>
                                        </div>
                                    </div>
                                </div>
                                <div class="card__content" bis_skin_checked="1">
                                    <div class="card__information" bis_skin_checked="1">
                                        <h3 class="card__heading h5">
                                            <a href="${productUrl}" class="full-unstyled-link" aria-label="Visit ${product.title} page">${product.title}</a>
                                        </h3>
                                        <div class="card-information" bis_skin_checked="1">
                                            <div class="price " bis_skin_checked="1">
                                                <div class="price__container" bis_skin_checked="1">
                                                    <div class="price__regular" bis_skin_checked="1">
                                                        <span class="visually-hidden visually-hidden--inline">Regular price</span>
                                                        <span class="price-item price-item--regular">
                                                            ${window.currencyCode}${selectedVariantPrice}
                                                        </span>
                                                    </div>
                                                    ${selectedVariantCompareAtPrice > 0 ? `
                                                        <div class="price__sale" bis_skin_checked="1">
                                                            <span class="visually-hidden visually-hidden--inline">Regular price</span>
                                                        <span>
                                                            <s class="price-item price-item--regular"></s>
                                                        </span>
                                                        <span class="visually-hidden visually-hidden--inline">Sale price</span>
                                                        <span class="price-item price-item--sale price-item--last">
                                                            ${window.currencyCode}${selectedVariantCompareAtPrice}
                                                        </span>
                                                        </div>` : ``
                                                    }
                                                </div>
                                                ${swatches}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="card__badge bottom left" bis_skin_checked="1"></div>
                                <div class="swymcs-product-buttons">
                                    <button ${isButtonDisabled} data-purpose="cart" data-du="${pdp.du}" data-epi="${selectedVariant.id}" data-empi="${product.id}" 
                                        class="${inCart} ${isSoldOut} swymcs-major-button swymcs-add-to-cart-btn swymcs-button" aria-label="${addToCartBtnText}">
                                        ${addToCartBtnText}
                                    </button>
                                    ${sizeDropDown}
                                </div>
                                ${preOrder}
                            </div>
                        </div>
                    </li>
                `;
            });
            this.productsContainer.innerHTML = productMarkup;
            this.productsContainer.classList.remove('swymcs-empty-list');
            this._scrollToTop();
        }

        _renderEmptyList(){
            this.productsContainer.classList.add('swymcs-empty-list');
            this.productsContainer.innerHTML = window.emptyListContent;
            this.productsContainer.querySelector('#swym-empty-wishlist-container').classList.remove('swym-hide-container');
        }

        async _renderShareListPopup(evt){
            this._closeAdditionalOptionsPopup();
            this._renderShareList();
        }

        async _renderAdditionalOptionsPopup (evt) {
            const page = document.querySelector('swym-wishlist-page');
            const target = evt.target;
            if(target.id == 'swymcs-additional-options') return; 
            page._hidePopupContainer(page.querySelector('.swym-active-popup'));
            const action = target.dataset.action; 
            page._closeAdditionalOptionsPopup();
            if(action == 'share') page._renderShareList();
            else if(action == 'delete') page._renderDeleteList();
        }

        _closeAdditionalOptionsPopup () {
            this._hideContainer(this.shareListPopup);
            this._hideContainer(this.deleteListPopup);
            this._hidePopupContainer(this.additionalOptionsPopupContainer);
        }

        async _renderShareList() {
            if(!window.isLoggedIn) {
                this._hidePopupContainer(this.additionalOptionsContainer);
                this._showPopupContainer(this.accountPopup);
                return;
            }

            const list = this.lists.find(list => list.lid == window.currentActiveListId);
            const shareableLink = await this._prepareShareLink(list);
            this.shareLinkField.textContent = shareableLink;
            
            !this.isShareEnabledUsingSocialMedia && this._hideContainer(this.additionalShareButtonsContainer);
            this._showContainer(this.shareListPopup);
            this._showPopupContainer(this.additionalOptionsPopupContainer);
            await this._markListAsPublic();
        }

        _markListAsPublic(){
            return new Promise(async (resolve, reject) => {
                this.swat.markListPublic(window.currentActiveListId,
                    list => resolve(list),
                    err => reject(err)
                );
            });
        }

        _renderDeleteList () {
            this.deleteListName.textContent = "your wishlist";
            this._showContainer(this.deleteListPopup);
            this._showPopupContainer(this.additionalOptionsPopupContainer);
        }

        /* Show / Hide containers */

        _overlayEvent(evt){
            if (evt.target.nodeName == 'BODY') {
                this.querySelectorAll(".swym-active-popup").forEach(popup => this._hidePopupContainer(popup));
              }
        }

        _scrollToTop () {
            const header = document.querySelector('.swymcs-page-header');
            if (header) {
                var targetOffsetTop = header.getBoundingClientRect().top + window.scrollY;
                window.scrollTo({
                    top: targetOffsetTop,
                    behavior: "smooth"
                });
            }
        }

        _showPopupContainer (selector) {
            selector.classList.remove('swym-hide-container');
            selector.classList.add('swym-active-popup');
            this.body.classList.add('no-scroll');
        }

        _hidePopupContainer (selector) {
            selector.classList.add('swym-hide-container');
            selector.classList.remove('swym-active-popup');
            this.body.classList.remove('no-scroll');
        }

        _showContainer (selector) {
            selector.classList.remove('swym-hide-container');
        }

        _hideContainer (selector) {
            selector.classList.add('swym-hide-container');
        } 

        /* Javascript APIs related functions */
        _getLists () {
            return new Promise(async (resolve, reject) => {
                this.swat.fetchLists({
                  callbackFn: lists => resolve(lists),
                  errorFn: err => reject(err)
                });
            });
        } 

        _getListDetails(lid){
            return new Promise(async (resolve, reject) => {
                this.swat.fetchListDetails(
                  { lid: lid },
                  list => resolve(list),
                  error => reject(error)
                );
            });
        }

        async _getCompleteListDetails(){
            const lists = await this._getLists();
            if(!lists.length) return lists;
            
            // Load only first 3 products for each list for preview
            await Promise.all(lists.map(async list => {
                const products = await this._getProductsFromList(list.lid);
                list.listcontents = products.slice(0, 3); // Only get first 3 products for preview
                list.listcontents = await this._getShopifyProductsData(list.listcontents);
                if(products.length <= 3) list.allProductsLoaded = true;
                list.totalProducts = products.length; // Store total count
            }));
            return lists;
        }

        _getProductsFromList(lid){
            return new Promise(async (resolve, reject) => {
                this.swat.fetchListCtx(
                  { lid: lid },
                  listContents => resolve(listContents),
                  error => reject(error)
                );
            });
        }
      
       async _getShopifyProductsData(products){
            if(!products.length) return []; 
            const section = this;   
            let buggedProductsArray = []; 
            let res = await Promise.all(products.map(async (pdp) => {
                try {
                    const productHandleString = pdp.du.split('/products/')[1];
                    const productHandle = productHandleString.split('?')[0];
                    const reqURL = `/products/${productHandle}`;
                    const productData = await fetch(`${reqURL}.js`);
                    const jsonData = await productData.json();
                    pdp.productData = jsonData;
                    return pdp;
                }
                catch(error){
                    const errorObj = {}; 
                    errorObj[pdp.du] = error; 
                    buggedProductsArray.push(errorObj);
                    return null; 
                }
            }));

            //console.log('Products with bugs - ', buggedProductsArray);
            res = res.filter(product => product && product.productData);
            return res;
        }

        _setListProperties(list, listContents, allProductsLoaded = false) {
            list.listcontents = listContents;
            list.totalProducts = listContents.length;
            list.allProductsLoaded = allProductsLoaded;
            return list;
        }

        _deleteProductFromList(product, lid, parentNode, listType){
            const onSuccessWishlist = async deletedProduct => {
                parentNode.remove();
                if(!this.productsContainer.querySelector('.swymcs-product-card')){
                    this._renderProductsGrid([]);
                }
                if(this.isSingleList) {
                    this.list.listcontents = this.list.listcontents.filter(product => product.epi !== deletedProduct.epi);
                    this.list = this._setListProperties(this.list, this.list.listcontents, true);
                    this._renderSingleListHeader(lid);
                } else {
                    this.lists = this.lists.map(list => {
                        if (list.lid === lid) {
                            const updatedListContents = list.listcontents.filter(product => product.epi !== deletedProduct.epi);
                            return this._setListProperties({...list}, updatedListContents, true);
                        }
                        return list;
                    });
                    this._renderListHeader(lid); 
                }
            }

            const onSuccessSFL = async response => {
                const deletedProduct = response.itemsdeleted[0];
                parentNode.remove();
                if(!this.productsContainer.querySelector('.swymcs-product-card')){
                    this._renderProductsGrid([], 'sfl');
                }
                this.sflList.listcontents = this.sflList.listcontents.filter(product => product.epi !== deletedProduct.epi);
            }
            const onError = error => console.log("Error while deleting the Product", error)
            if(listType == 'wishlist') this.swat.deleteFromList(lid, product, onSuccessWishlist, onError);
            else if(listType == 'sfl') this.swat.SaveForLater.remove(lid, [product], onSuccessSFL, onError);
        }

        _deleteList(){
            const onSuccess = deletedListObj => {
                this._closeAdditionalOptionsPopup();
                this.lists = this.lists.filter(list => list.lid != window.currentActiveListId);
                this._hideContainer(this.listProductsContainer);
                this._showContainer(this.pageLoader);
                if(this.isSingleList) {
                    this.list = null;
                }
                this.isSingleList ? this._renderSingleList() : this._renderMultipleList();
            }
            const onError = error => console.log(`Error while deleting the List, ${lid}`, error);
            _swat.deleteList(window.currentActiveListId, onSuccess, onError);
        }

        _validateListName(name, errorField){
            const isValidList = false;
            if(name.length < 3){
                errorField.textContent = 'Name must be longer than 3 characters';
                return isValidList; 
            }
            const lists = this.lists;
            const matchedList = lists.find(list => list.lname.trim().toLowerCase() == name);
            if(matchedList) {
                errorField.textContent = 'List name already exists';
                return isValidList;
            }
            errorField.textContent = '';
            return !isValidList;
        }

        _validateEmail() {
            const emailPattern = /^\w+([.-]\w+)*@\w+([.-]\w+)*(\.\w{2,4})+$/;
            const isBlank = this.shareEmailField.value=='' ? true : false;
            const isInvalidString = !this.shareEmailField.value.match(emailPattern) ? true : false;
            if(isBlank || isInvalidString){
                this.shareListError.textContent = isBlank ? 'Please enter the email address' : 'Please enter a valid email address';
                return false;
            }
            this.shareListError.textContent = '';
            return true;
        }

        _addProductToCart(button){
            const epi = +button.dataset.epi;
            const empi = +button.dataset.empi;
            const du = button.dataset.du;
            this.swat.replayAddToCart({
                empi,
                du,
                qty: 1
            }, epi, (c) => {
                button.classList.add('swymcs-product-in-cart');
                button.textContent = 'Added to bag'; 
                document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
                const product = this.wishlistVariants[empi];
                if (product) {
                    for (const colorKey in product) {
                        for (const sizeKey in product[colorKey]) {
                            const variant = product[colorKey][sizeKey];
                            if (variant.epi === epi) {
                                variant.inCart = true;
                            }
                        }
                    }
                }
                document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {bubbles: true}));
            }, (error) => {
                console.log("Error",error);
                _swat.ui.uiRef.showErrorNotification({ message: error.description });
            }); 
        }

        _prepareShareLink(list){
            return new Promise(async (resolve, reject) => {
                this.swat.generateSharedListURL(list.lid,
                    (link, lid) => resolve(link, lid),
                    err => reject(err)
                );
            });
        }

        _shareListByCopy(){
            navigator.clipboard.writeText(this.shareLinkField.textContent)
            .then(() => _swat.ui.uiRef.showSuccessNotification({ message: 'Link Copied to Clipboard!' }))
            .catch(error => _swat.ui.uiRef.showErrorNotification({message: error.description}));
        }

        _shareListByEmail(){
            const email = this._validateEmail();
            if(!email) return;
            const onSuccess = response => {
                _swat.ui.uiRef.showSuccessNotification({message: 'List shared successfully over mail'});
                this._closeAdditionalOptionsPopup();
            }
            const onError = error => _swat.ui.uiRef.showErrorNotification({message: error.description});
            _swat.sendListViaEmail({
                'toEmailId': this.shareEmailField.value.trim(),
                'note': this.shareMessageField.value,
                'fromName': this.shareNameField.value,
                'lid': window.currentActiveListId,
            }, onSuccess, onError);
        }

        _shareListOnPlatform(platform){
            const shareUrl = this.shareLinkField.textContent;
            const note = this.shareMessageField.value;
            const fromName = this.shareNameField.value;
            const onError = error => _swat.ui.uiRef.showErrorNotification({message: error.description});
            let platformShareUrlTemplate = '';
            if(platform == 'facebook') 
                platformShareUrlTemplate = `https://www.facebook.com/sharer.php?u=${shareUrl}&t=${note}`;
            else if(platform == 'twitter')  
                platformShareUrlTemplate = `https://twitter.com/share?text=${note}&url=${shareUrl}`; 
            _swat.shareListSocial(window.currentActiveListId, fromName, platformShareUrlTemplate, platform, note, onError)
        }

        /* Header functions */
        _loginButtonAction(evt){
            const redirectionUrl = evt.currentTarget.getAttribute('data-redirection-url');
            const actionUrl = evt.currentTarget.getAttribute('data-action-url');
            localStorage.setItem('SWYM_REDIRECT_URL', redirectionUrl);
            localStorage.setItem('SWYM_ACTION_URL', actionUrl);
            location.href = actionUrl;
        }

        /* Product Grid Events */
        async _eventsForProductsGrid (evt) {
            const target = evt.target;
            const page = document.querySelector('swym-wishlist-page');
            const purpose = target.dataset?.purpose;
            if(!purpose) return; 
            evt.preventDefault();
            if(purpose == 'cart') page._addProductToCart(target);
            else if(purpose == 'select') page._selectProductSize(target);
            else if(purpose == 'swatch' && !target.classList.contains('swym-selected-swatch')) page._selectProductColor(target);
            else if (purpose == 'delete'){
                page._deleteProductFromList(
                    {
                        "epi": target.dataset.epi,
                        "empi": target.dataset.empi,
                        "du": target.dataset.du
                    }, target.dataset.lid, target.closest('.swymcs-product-card'), target.dataset.listType
                );
            }
        }

        _selectProductColor(target){
            const productCard = target.closest("li.grid__item.swymcs-product-card");
            const swatches = target.closest(".swymcs-swatches");
            const image = productCard.querySelector('.card__media img');
            const sizeSelector = productCard.querySelector('.swymcs-size-select');
            const size = productCard.querySelector('.swymcs-size-select')?.value || "single";
            const atc = productCard.querySelector(`[data-purpose="cart"]`);
            swatches.querySelector('.swym-selected-swatch').classList.remove('swym-selected-swatch');
            target.classList.add('swym-selected-swatch');
            image.src = target.dataset.image;
            console.log("this.wishlistVariants",this.wishlistVariants[productCard.dataset.empi][target.dataset.color]);
            const variant = (size && this.wishlistVariants[productCard.dataset.empi][target.dataset.color][size]);
            if(variant){
                atc.dataset.epi = variant?.epi;
                const stateMap = {
                    soldOut: { class: 'swymcs-sold-out', text: this.settings.sold_out_text, disabled: true },
                    inCart: { class: 'swymcs-product-in-cart', text: this.settings.added_to_cart_text, disabled: false },
                    default: { class: '', text: this.settings.add_to_cart_text, disabled: false }
                };
                const state = !variant.available ? 'soldOut' : variant.inCart ? 'inCart' : 'default';
                const { class: newClass, text, disabled } = stateMap[state];
                atc.classList.remove('swymcs-product-in-cart', 'swymcs-sold-out');
                if (newClass) atc.classList.add(newClass);
                atc.disabled = disabled;
                atc.textContent = text;
            }
            if (sizeSelector) {
                const variantsForColor = this.wishlistVariants[productCard.dataset.empi][target.dataset.color];
                Object.keys(variantsForColor).forEach(s => {
                    const option = sizeSelector.querySelector(`option[value="${s}"]`);
                    console.log("option",option);
                    if (option) {
                        option.disabled = !variantsForColor[s].available;
                    }
                });
            }        
        }

        _selectProductSize(target){
            const productCard = target.closest("li.grid__item.swymcs-product-card");
            const swatches = productCard.querySelector(".swymcs-swatches");
            const color = swatches?.querySelector('.swym-selected-swatch').dataset.color || "single";
            const size = target.value || "single";
            const atc = productCard.querySelector(`[data-purpose="cart"]`);
            const variant = this.wishlistVariants[productCard.dataset.empi][color][target.value];
            if(variant){
                atc.dataset.epi = variant?.epi;
                const stateMap = {
                    soldOut: { class: 'swymcs-sold-out', text: this.settings.sold_out_text, disabled: true },
                    inCart: { class: 'swymcs-product-in-cart', text: this.settings.added_to_cart_text, disabled: false },
                    default: { class: '', text: this.settings.add_to_cart_text, disabled: false }
                };
                const state = !variant.available ? 'soldOut' : variant.inCart ? 'inCart' : 'default';
                const { class: newClass, text, disabled } = stateMap[state];
                atc.classList.remove('swymcs-product-in-cart', 'swymcs-sold-out');
                if (newClass) atc.classList.add(newClass);
                atc.disabled = disabled;
                atc.textContent = text;
            }
        }
    }
    customElements.define('swym-wishlist-page', SwymWishlistPage);
}